import { Tabs, Empty, theme, Button, Flex, Avatar, Typography } from "antd";
import {
  UserOutlined
} from '@ant-design/icons';
import AnnotationBubble from "./AnnotationBubble";
import UserBubble from "./UserBubble";

const { Title } = Typography;

function AnnotationPanel({ annotations, onJumpToAnnotation, onAddAnnotation }) {
  const comments = annotations.filter(a => a.type === "comment" || a.type === "voice" || a.type === "scribble");
  const bookmarks = annotations.filter(a => a.type === "bookmark");
  const {
    token: {
      colorBgContainer,
      borderRadiusLG,
      colorPrimary,
      colorPrimaryBorder,
      colorTextDescription,
      colorBorder,
      fontSizeSM,
      colorError,
      colorBgElevated,
      colorBorderSecondary,
      colorTextSecondary,
      colorWarning,
    },
  } = theme.useToken();

  // Function to add a sample comment
  const addSampleComment = () => {
    const sampleComment = {
      pdfId: "sample-pdf",
      page: 1,
      type: "comment",
      boundingBox: { x: 0.1, y: 0.1, width: 0.2, height: 0.1 },
      commentText: "This is a sample comment",
      visibility: "public",
      sharedWith: ["user1"],
      color: colorPrimary,
    };
    onAddAnnotation(sampleComment);
  };

  const tabItems = [
    {
      key: '1',
      label: 'Comments & Drawings',
      children: (
        <div style={{ padding: 8 }}>
          {/* Sample Comment  */}
          <Flex vertical gap={12}>
          <AnnotationBubble  />
          <AnnotationBubble />
          </Flex>
          {/* sample End  */}
          {comments.length === 0 ? (
            <Empty description="No comments or drawings" />
          ) : (
            comments.map((ann, i) => (
              <div
                key={i}
                style={{
                  marginBottom: 10,
                  padding: 8,
                  background: colorBgContainer,
                  borderRadius: borderRadiusLG,
                  border: `1px solid ${colorBorder}`,
                  cursor: "pointer"
                }}
                onClick={() => onJumpToAnnotation(ann)}
              >
                <div>
                  <b>Page {ann.page}</b>
                </div>
                {ann.type === "voice" ? (
                  <>
                    <audio controls src={ann.voiceBlob}></audio>
                    <div><i>{ann.transcript}</i></div>
                  </>
                ) : ann.type === "comment" ? (
                  ann.commentText && <div>{ann.commentText}</div>
                ) : ann.type === "scribble" ? (
                  <div><i>Freehand Drawing</i></div>
                ) : null}
              </div>
            ))
          )}
        </div>
      ),
    },
    {
      key: '2',
      label: 'Bookmarks',
      children: (
        <div style={{ padding: 8 }}>
          {bookmarks.length === 0 ? (
            <Empty description="No bookmarks" />
          ) : (
            bookmarks.map((ann, i) => (
              <div
                key={i}
                style={{
                  marginBottom: 10,
                  padding: 8,
                  background: colorBgElevated,
                  borderRadius: borderRadiusLG,
                  border: `1px solid ${colorBorderSecondary}`,
                  cursor: "pointer"
                }}
                onClick={() => onJumpToAnnotation(ann)}
              >
                <b>Page {ann.page} 🔖</b>
              </div>
            ))
          )}
        </div>
      ),
    }
  ];

  return (
    <div style={{ overflowY: "auto" }}>
      <Tabs
        defaultActiveKey="1"
        items={tabItems}
        style={{ padding: '0 8px' }}
        tabBarStyle={{
          marginBottom: 16,
          borderBottom: `1px solid ${colorBorder}`,
        }}
      />
    </div>
  );
}

export default AnnotationPanel;